import Search from './Search'
import DocumentReference from './DocumentReference'
import History from './History'

export default [{
  path: '/search/reference/:document_id',
  name: 'DocumentReference',
  component: DocumentReference,
  meta: {
    auth: true,
    bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer',
    title: 'Search Document Reference',
    tour: false}
}, {
  path: '/search/history/:listId?',
  name: 'SearchHistory',
  component: History,
  props: true,
  meta: {
    auth: true,
    bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer',
    title: 'Search History',
    tour: false
  }
}, {
  path: '/search/datas/:query',
  name: 'SearchWithData',
  component: Search,
  meta: {
    auth: true,
    bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer',
    title: 'Explore',
    tour: true
  }
}, {
  path: '/search/:query?',
  name: 'Search',
  component: Search,
  meta: {
    auth: true,
    bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer',
    title: 'Explore',
    tour: true
  }
}, {
  path: '/searchSimple/:query?',
  name: 'SearchSimple',
  component: Search,
  meta: {
    auth: true,
    bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer',
    title: 'Search Simple',
    tour: true
  }
}]



// WEBPACK FOOTER //
// ./src/pages/search/router.js